import React from 'react';

export const NoRowsWithSearchOverlay = ({
  noRowsMessageFunc,
}: {
  noRowsMessageFunc: string;
}) => {
  return <div className="ag-overlay-loading-center">{noRowsMessageFunc}</div>;
};
